import api from '../../../App/socket';
import { LEAD_STATUS } from '../../constants/leadStatuses';

export const changeLeadStatus = (_id, status_id, requestParams) => {
    let update = {};

    if (status_id === LEAD_STATUS.doNotWantTrade) {
        update = {
            lead_pot: 'Black',
            ref_lead_status: status_id,
            'trade.is_trade': status_id === '5fd27dc61dc278430e324b21' || status_id === '5beabf6166676f89160edfc0' || status_id === '5beabef666676f89160edfbf' || status_id === '5beabf6166676f89160edfc3' || status_id === '5f92fded338def1a9607ae36' || status_id === '5f92fb12338def1a9607ae34' || status_id === '5f92fafd338def1a9607ae33' || status_id === '5f92fafd338def1a9607ae33' || status_id === '5f8863f1d88a9007b68aa742' || status_id === '5f886198d88a9007b68aa741' || status_id === '5f886009d88a9007b68aa740' || status_id === '5f885dc8d88a9007b68aa73f' || status_id === '5f85a3ead88a9007b68aa73d' || status_id === '5f858829d88a9007b68aa73c' || status_id === '5f8582b8d88a9007b68aa73b' || status_id === '5f85823bd88a9007b68aa73a' || status_id === '5f85820bd88a9007b68aa739' || status_id === '5f858198d88a9007b68aa738' || status_id === '5f8578e3d88a9007b68aa737' || status_id === '5f8574fcd88a9007b68aa736' || status_id === LEAD_STATUS.doNotWantTrade || status_id === LEAD_STATUS.pendingTrade || status_id === '5f8574aed88a9007b68aa733' || status_id === LEAD_STATUS.scrapBike || status_id === '5f8574e3d88a9007b68aa735',
        };
    } else {
        update = {
            ref_lead_status: status_id,
            'trade.is_trade': status_id === '5fd27dc61dc278430e324b21' || status_id === '5beabf6166676f89160edfc0' || status_id === '5beabef666676f89160edfbf' || status_id === '5beabf6166676f89160edfc3' || status_id === '5f92fded338def1a9607ae36' || status_id === '5f92fb12338def1a9607ae34' || status_id === '5f92fafd338def1a9607ae33' || status_id === '5f92fafd338def1a9607ae33' || status_id === '5f8863f1d88a9007b68aa742' || status_id === '5f886198d88a9007b68aa741' || status_id === '5f886009d88a9007b68aa740' || status_id === '5f885dc8d88a9007b68aa73f' || status_id === '5f85a3ead88a9007b68aa73d' || status_id === '5f858829d88a9007b68aa73c' || status_id === '5f8582b8d88a9007b68aa73b' || status_id === '5f85823bd88a9007b68aa73a' || status_id === '5f85820bd88a9007b68aa739' || status_id === '5f858198d88a9007b68aa738' || status_id === '5f8578e3d88a9007b68aa737' || status_id === '5f8574fcd88a9007b68aa736' || status_id === LEAD_STATUS.doNotWantTrade || status_id === LEAD_STATUS.pendingTrade || status_id === '5f8574aed88a9007b68aa733' || status_id === LEAD_STATUS.scrapBike || status_id === '5f8574e3d88a9007b68aa735',
        };
    }

    // On clicking Scrap button -> ref_lead_status: 'Pending (Trade), is_trade: true, lead_pot: Black
    if (status_id === LEAD_STATUS.pendingTrade && requestParams.lead_pot === 'Black') {
        update.lead_pot = requestParams.lead_pot;
    }

    return api.send({
        api: 'db',
        model: 'Lead',
        action: 'Update',
        options: {
            where: { _id },
            update,
        },
    }).then((response) => response).catch((error) => error);
};

export const getLeadsStatus = () => api.send(
    {
        api: 'db',
        model: 'Lead_status',
        action: 'Read',
        options: {
            attributes: 'all',
            include:
                    {
                        model: 'Lead_status',
                        path: 'children',
                        attributes: 'all',
                    },
        },
    },
).then((response) => response).catch((error) => error);


// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/lead_manage_lead_status_request.js